import { type LoaderFunctionArgs } from '@remix-run/node'
import { Outlet, useLoaderData } from '@remix-run/react'
import { getUserId } from '#app/utils/auth.server.ts'
import { isPublicSignupEnabled } from '#app/utils/signup-flag.server.ts'
import { MarketingFooter } from './components/marketing-footer.tsx'
import { MarketingHeader } from './components/marketing-header.tsx'
import './styles/marketing.css'

export const loader = async ({ request }: LoaderFunctionArgs) => {
	const userId = await getUserId(request)
	return {
		isAuthenticated: Boolean(userId),
		signupEnabled: isPublicSignupEnabled(),
	}
}

export default function MarketingLayout() {
	const { isAuthenticated, signupEnabled } = useLoaderData<typeof loader>()
	return (
		<div className="marketing-scope min-h-screen bg-ink text-ink-fg">
			<MarketingHeader
				isAuthenticated={isAuthenticated}
				signupEnabled={signupEnabled}
			/>
			<main>
				<Outlet context={{ isAuthenticated, signupEnabled }} />
			</main>
			<MarketingFooter />
		</div>
	)
}
